import React, { useReducer, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { forgotPassword } from '../../../utils/APIUtils';
import { handleValidation } from '../../../utils/formUtils';
import securityConfig from '../../../utils/securityConfig';
import { notificationManager } from '../../../utils/NotificationUtils';
import '../login/login.scss';
import { Button, CircularProgress, InputAdornment, TextField } from '@material-ui/core';
import PersonIcon from '@material-ui/icons/Person';

const ForgotPassword = () => {
  const history = useHistory();
  const [fields, setFields] = useReducer((state, newState) => ({ ...state, ...newState }), {
    email: {
      value: '',
      fieldName: 'Email',
      errors: {},
      validations: ['required', 'validEmail'],
    },
  });

  const [loading, setLoading] = useState(false);

  const validate = () => {
    let isValid = true;
    const updatedFields = {};
    for (let field in fields) {
      const currField = { ...fields }[field];
      if (handleValidation(currField)) isValid = false;
      updatedFields[field] = currField;
    }
    setFields(updatedFields);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setLoading(true);
      try {
        const response = await forgotPassword(fields.email.value.toLowerCase());
        if (response) {
          history.push({
            pathname: '/set-password',
            email: fields.email.value.toLowerCase(),
            action: 'forgotPassword',
          });
          notificationManager('success', 'Password reset details have been send to your email');
        }
      } catch (e) {
        if (e.message === 'Username/client id combination not found.') {
          notificationManager('danger', 'User email not found');
        } else {
          notificationManager('danger', e.message.replace('GraphQL error:', ''));
        }
      } finally {
        setLoading(false);
      }
    }
  };

  const handleInputChange = (e, type) => {
    const inputValue = e.target.value;
    const currField = { ...fields }[type];

    currField.value = inputValue;
    handleValidation(currField);

    setFields({
      [type]: currField,
    });
  };

  return (
    <form onSubmit={handleSubmit} noValidate autoComplete={securityConfig.autoCompleteOff ? 'off' : 'on'}>
      <div className='row d-flex justify-content-center align-items-center mb-3 content mx-0'>
        <div className='header-row d-flex justify-content-center'>
          <span className='app-greeting ms-1'>Forgot Password</span>
        </div>
      </div>
      <div className='row d-flex justify-content-center align-items-center  mx-0'>
        <div className='col-md-5 mb-3 d-flex justify-content-center'>
          <TextField
            id='email'
            label='Email'
            required
            className='col-md-6'
            onChange={(e) => handleInputChange(e, 'email')}
            error={!!fields.email.errors.required || !!fields.email.errors.validEmail}
            helperText={fields.email.errors.required || fields.email.errors.validEmail}
            inputProps={{
              autoComplete: securityConfig.autoCompleteOff ? 'off' : 'on',
              ...(securityConfig.autoCompleteOff ? { readOnly: true, onFocus: (e) => e.target.removeAttribute('readonly') } : {}),
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position='end'>
                  <PersonIcon />
                </InputAdornment>
              ),
            }}
          />
        </div>
      </div>
      <div className='row d-flex justify-content-center align-items-center mt-4 mx-0'>
        <div className='col-md-12 mb-3 d-flex justify-content-center'>
          {loading ? (
            <CircularProgress color='primary' />
          ) : (
            <Button variant='contained' type='submit' color='primary' size='large'>
              Confirm
            </Button>
          )}
        </div>
        <div className='col-md-12 mb-3 d-flex justify-content-center'>
          Remember your password? &nbsp;
          <span className='forgot-password' onClick={() => history.push('/login')}>
            {' '}
            Login
          </span>
        </div>
      </div>
    </form>
  );
};

export default ForgotPassword;
